export default {
  districts: [],
  districtTo: [],
  districtFrom: [],
  district: {},
  districtsByCityCode: {},
  districtKind: [],
  districtsByCityId: {}
}



// WEBPACK FOOTER //
// ./src/components/district/store/state.js